import { PubSubService } from './pubsub.service';

export default angular
  .module('sfMobile.services.pubsub', [])
  .service('pubSubService', PubSubService).name;
